import QRcode from "v-qrcode/src/index.vue";
import {DigitalSignageTV} from "@/models/digital-signage/DigitalSignageTV";
import {UAParser} from "ua-parser-js";

export default {
  name: "DigitalSignageQRCode",
  components: {
    QRcode
  },
  data() {
    return {
      qrCode: null,
      subscribeOnDigitalSignageTV: null,
      deviceInfo: null,
      browserInfo: null,
      osInfo: null,
    }
  },
  computed: {
    digitalSignageTV() {
      return this.$store.state.digitalSignageModule.digitalSignageTV;
    }
  },
  watch: {
    digitalSignageTV(newValue, oldValue) {
      if(newValue?.isAuth && !oldValue?.isAuth) {
        this.$router.push({ path: "/digital-signage-tv" });
      }
    }
  },
  async created() {
    const digitalSignageTV = await this.initDevice();
    await this.$store.dispatch("initDigitalSignageTV", digitalSignageTV);
    await this.$store.dispatch("subscribeOnDigitalSignageTV", this.digitalSignageTV.id);
  },
  methods: {
    async initDevice() {
      const parser = new UAParser();
      const device = await parser.getResult();

      console.log("DEVICE ", device)

      const TV = new DigitalSignageTV();
      TV.model = device.device.model ?? null;
      TV.brand = device.device.vendor ?? null;
      TV.osName = device.os.name ?? null;
      TV.osVersion = device.os.version ?? null;
      TV.browserName = device.browser.name ?? null;
      TV.browserVersion = device.browser.major ?? null;
      TV.ua = device.ua ?? null;
      TV.screenSize = `${window.screen.width}x${window.screen.height}`;

      return Object.assign({}, TV);
    },
    back() {
      console.log("Back")
    }
  }
}